<router-outlet />
<vw-app-loader></vw-app-loader>

<!-- Au niveau du shell : l'activation peut venir d'un retour de paiement, d'un
     essai lancé depuis n'importe quel paywall, ou de mois offerts par l'admin.
     La célébration doit suivre l'utilisateur, pas l'écran d'où il est parti. -->
<vw-premium-celebration
  [isOpen]="premiumService.justUpgraded()"
  [trial]="isTrialActivation()"
  [trialEnd]="premiumService.subscription()?.currentPeriodEnd"
  (closed)="premiumService.acknowledgeUpgrade()"
></vw-premium-celebration>

<!-- Permission des notifications (coque 1.5.1+) et alerte reçue app ouverte :
     au niveau du shell, elles suivent l'utilisateur d'un écran à l'autre. -->
<vw-push-permission-toast></vw-push-permission-toast>
<vw-push-banner></vw-push-banner>

<!-- Coque sous le build minimal de /app-config : plein écran, avec une issue. -->
<vw-app-update-screen></vw-app-update-screen>

<!-- Session non vérifiable (réseau coupé, serveur en redéploiement) : les jetons
     sont gardés, on propose de réessayer au lieu de renvoyer vers la connexion. -->
<vw-session-offline-screen></vw-session-offline-screen>
